export default __webpack_public_path__ + "static/media/info-gray.a355080f.svg";